import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Typography,
    Button,
} from "@material-ui/core";
import Cookies from "universal-cookie";

import ButtonClose from "../../../../../../../../util/buttonClose/.mixins/buttonClose";

//assets
import gif_nota_light from "../../../../../../../../../assets/notas_fiscais_gif_light_mode.gif";
import gif_nota_dark from "../../../../../../../../../assets/notas_fiscais_gif_dark_mode.gif";

export default function ModalAvisoSplitNota(props) {
    const { isModalOpen, handleDialogModal } = props;

    const cookies = new Cookies();
    const color = cookies.get("System-Color");

    function HeaderModal() {
        return (
            <div>
                <Typography variant="h6" align="center" style={{ marginLeft: "20px" }}>
                    <ButtonClose closeMethod={handleDialogModal} />
                    Opções de recebimento definidas com sucesso!
                </Typography>
            </div>
        );
    }

    function BodyModal() {
        return (
            <div align="center">
                <img src={color === "dark" ? gif_nota_dark : gif_nota_light} width="300px"></img>

                <Typography variant="h6" align="center">
                    <strong>
                        Será necessário emitir múltiplas notas fiscais para esta data de entrega
                    </strong>{" "}
                    pois existem dois ou mais prazos de pagamento diferentes neste dia.
                </Typography>
            </div>
        );
    }

    function ButtonModal() {
        return (
            <>
                <Typography style={{ padding: "0px", marginBottom: "32.5px" }} align="center">
                    <Button
                        variant="contained"
                        onClick={handleDialogModal}
                        color="primary"
                        style={{ padding: "7.5px 20px" }}
                    >
                        Entendido
                    </Button>
                </Typography>
            </>
        );
    }

    return (
        <Dialog open={isModalOpen} scroll="paper">
            <DialogTitle>
                <HeaderModal />
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="scroll-dialog-description">
                    <BodyModal />
                </DialogContentText>
            </DialogContent>

            <ButtonModal />
        </Dialog>
    );
}
